(function(){
    'use strict';

    angular
       .module('appback')
       .factory('HojaService', HojaService);

   HojaService.$inject = ['$http'];

   function HojaService($http){


       var service= {
          getLineasFabricacionByHoja:getLineasFabricacionByHoja,
          getProductosByProveedor:getProductosByProveedor,
          getHojaFabricacion:getHojaFabricacion,
          finalizarFabricacion:finalizarFabricacion,
          guardarFabricacion:guardarFabricacion,
          finalizarValidacion:finalizarValidacion,
          desvalidarValidacion:desvalidarValidacion,
          setHojaFabricacionAccion:setHojaFabricacionAccion,
          getValidacionesHojaFabricacion:getValidacionesHojaFabricacion,
          setValidaciones:setValidaciones,
          getValidaciones:getValidaciones,
          getStockSeleccionadoLinea:getStockSeleccionadoLinea,
          //new edu
          getMaterialesPreparacion:getMaterialesPreparacion,
          nuevoLoteFifo:nuevoLoteFifo,
          getLote:getLote,
          getMaterial:getMaterial,
          setHojaFabricacion:setHojaFabricacion,
          getMovimientosHojaFabricacion:getMovimientosHojaFabricacion,
          getCoa:getCoa,
          getFlujosHojaFabricacion:getFlujosHojaFabricacion,
          setFlujoHojaFabricacion:setFlujoHojaFabricacion,
          getCategoriasFlujos:getCategoriasFlujos,
          finalizarFlujoHojaFabricacion:finalizarFlujoHojaFabricacion,
          cambiarLoteLineaFabricacion:cambiarLoteLineaFabricacion,
          removeLineaDuplicada:removeLineaDuplicada,
          base64toJPG:base64toJPG,
          getProximoLoteHoja:getProximoLoteHoja,
          getCaducidadHoja:getCaducidadHoja,
          addGastoIndirecto:addGastoIndirecto,
          desecharStock:desecharStock,
          getLoteFifoAlmacen:getLoteFifoAlmacen,
          getEstadisticas:getEstadisticas,
          updateUnidadesCajas:updateUnidadesCajas
       };

       return service;
       function getMovimientosHojaFabricacion(hoja_fabricacion_id,callback){
        var config = {
               headers : {
                   'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
               }
           }

           $http.get('/backend/hojafabricacion/getmovimientoshoja', { params : { hoja_fabricacion_id : hoja_fabricacion_id }  }, config)
           .then(getContentSuccess,getContentFailed);
           function getContentSuccess(data){ 
               callback(data.data);
           }
           function getContentFailed(data){
               
               return false;
           }
       }
       function getCoa(hoja_fabricacion_id,material_id,callback){
        var config = {
               headers : {
                   'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
               }
           }

           $http.get('/backend/hojafabricacion/getcoahojafabricacion', { params : { hoja_fabricacion_id: hoja_fabricacion_id, material_id : material_id }  }, config)
           .then(getContentSuccess,getContentFailed);
           function getContentSuccess(data){ 
               callback(data.data);
           }
           function getContentFailed(data){
               
               return false;
           }
       }
        function addGastoIndirecto(gasto,filtros,callback)
       {
           var config = {
               headers : {
                   'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
               },
           }
           var data = $.param({ 
               gasto:JSON.stringify(gasto),
               filtros:JSON.stringify(filtros)
           });
           $http.post('/backend/hojafabricacion/addgastoindirecto',data, config)
           .then(getContentSuccess,getContentFailed);
           function getContentSuccess(data){ 
               callback(data.data);
           }
           function getContentFailed(data){
               
               return false;
           }
       }

       function base64toJPG(filename,base64,callback)
       {
           var config = {
               headers : {
                   'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
               },
           }
           var data = $.param({ 
               filename:filename,
               base64:base64
           });
           $http.post('/backend/hojafabricacion/base64toimg',data, config)
           .then(getContentSuccess,getContentFailed);
           function getContentSuccess(data){ 
               callback(data.data);
           }
           function getContentFailed(data){
               
               return false;
           }
       }

       function getProximoLoteHoja(material_id, pais_id,metodo_generacion_lote,callback)
       {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/hojafabricacion/getproximolotehoja', { params : { material_id : material_id, pais_id : pais_id, metodo_generacion_lote : metodo_generacion_lote }  }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
       }
       function getCaducidadHoja(fecha_fabricacion, callback)
       {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/hojafabricacion/getcaducidadhoja', { params : { fecha_fabricacion : fecha_fabricacion }  }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }

       }
       function nuevoLoteFifo(material,callback)
       {

           var config = {
               headers : {
                   'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
               }
           }

           $http.get('/backend/hojafabricacion/getnuevolotefifo', { params : { material : JSON.stringify(material) }  }, config)
           .then(getContentSuccess,getContentFailed);
           function getContentSuccess(data){ 
               callback(data.data);
           }
           function getContentFailed(data){
               
               return false;
           }
           
       }
       function getLote(stock_id,callback)
       {

           var config = {
               headers : {
                   'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
               }
           }

           $http.get('/backend/hojafabricacion/getlote', { params : { stock_id : stock_id }  }, config)
           .then(getContentSuccess,getContentFailed);
           function getContentSuccess(data){ 
               callback(data.data);
           }
           function getContentFailed(data){
               
               return false;
           }
           
       }
       function getMaterial(material_id,callback)
       {

           var config = {
               headers : {
                   'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
               }
           }

           $http.get('/backend/hojafabricacion/getmaterial', { params : { material_id : material_id }  }, config)
           .then(getContentSuccess,getContentFailed);
           function getContentSuccess(data){ 
               callback(data.data);
           }
           function getContentFailed(data){
               
               return false;
           }
           
       }
       function getMaterialesPreparacion(filtros,callback)
       {

           var config = {
               headers : {
                   'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
               }
           }

           $http.get('/backend/hojafabricacion/getmaterialespreparacion', { params : {  filtros : JSON.stringify(filtros)  }  }, config)
           .then(getContentSuccess,getContentFailed);
           function getContentSuccess(data){ 
               callback(data.data);
           }
           function getContentFailed(data){
               
               return false;
           }
           
       }

       function setHojaFabricacion(hojaFabricacion,filtros,callback)
       {
            var config = {
               headers : {
                   'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
               }
            }
            var postParams = $.param(
            {
                hojaFabricacion:JSON.stringify(hojaFabricacion),
                filtros:JSON.stringify(filtros)
            }
           );

           $http.post('/backend/hojafabricacion/sethojafabricacion',  postParams  , config)
           .then(getContentSuccess,getContentFailed);
           function getContentSuccess(data){ 
               callback(data.data);
           }
           function getContentFailed(data){
            console.log('sethojafabricacion error', data)
               
               return false;
           }
           
       }
       function getLineasFabricacionByHoja(num_orden,callback) 
       {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            $http.get('/backend/hojafabricacion/getlineasfabricacionbyhoja',  { params : {num_orden:num_orden}  }  , config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
       }
       function getProductosByProveedor(proveedor_id,callback) 
       {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            $http.get('/backend/hojafabricacion/getproductosbyproveedor',  { params : {proveedor_id:proveedor_id}  }  , config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
       }

       function getHojaFabricacion(id_hoja_fabricacion_dada,callback) 
       {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            $http.get('/backend/hojafabricacion/gethojafabricacion',  { params : {id_hoja_fabricacion:id_hoja_fabricacion_dada}  }  , config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
       }

       function finalizarFabricacion(hojafabricacionactiva,callback) 
       {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            console.log("service finalizar", hojafabricacionactiva.lineashoja)
            var postParams = $.param(
            {
                "lineashoja":JSON.stringify(hojafabricacionactiva.lineashoja),
                "costes_indirectos":JSON.stringify(hojafabricacionactiva.materiales_fabricacion_indirectos),
                "hojafabricacion": JSON.stringify({ 
                    id:hojafabricacionactiva.id,
                    unidades:hojafabricacionactiva.unidades, 
                    unidades_previstas : hojafabricacionactiva.unidades_previstas,
                    almacen_id:hojafabricacionactiva?.almacen_id,
                    observaciones:hojafabricacionactiva.observaciones,
                })
            });
            $http.post('/backend/hojafabricacion/finalizarfabricacion',  postParams  , config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
       }

       function guardarFabricacion(hojafabricacionactiva,callback) 
       {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            console.log("service finalizar", hojafabricacionactiva.lineashoja)
            var postParams = $.param(
            {
                "lineashoja":JSON.stringify(hojafabricacionactiva.lineashoja),
                "hojafabricacion": JSON.stringify({ 
                    id:hojafabricacionactiva.id,
                    unidades:hojafabricacionactiva.unidades, 
                    unidades_previstas : hojafabricacionactiva.unidades_previstas,
                    almacen_id:hojafabricacionactiva?.almacen_id,
                    observaciones:hojafabricacionactiva.observaciones,
                })
            });
            $http.post('/backend/hojafabricacion/guardarfabricacion',  postParams  , config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
       }
       
       function getStockSeleccionadoLinea(lineaFabricacion,material_id,kits_a_preparar,callback) 
       {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var getparams = {
                lote_id:lineaFabricacion.stock_seleccionado.id,
                cantidad_a_multiplicar:kits_a_preparar,
                diasacaducar:lineaFabricacion.productoausar.diasdecaducidad ?? 0,
                hojafabricacion_id:lineaFabricacion.hojafabricacion_id,
                material_id:lineaFabricacion.material_id
            };
            if (!lineaFabricacion.stock_seleccionado.id){
                console.log('getparams getStockSeleccionadoLinea NO VOY',lineaFabricacion.stock_seleccionado)
                return false;
            }

            $http.get('/backend/hojafabricacion/getstockbyloteid',  { params : getparams }  , config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                console.log('Error', data)
                return false;
            }
       }

       function cambiarLoteLineaFabricacion(lineaHojaFabricacion, callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var postParams = $.param(
            {
                lineaHojaFabricacion:JSON.stringify(lineaHojaFabricacion),
                newStockID:lineaHojaFabricacion.stock_seleccionado.id
            }
            );
            console.log('cambiarLoteLineaFabricacion postParams', postParams)
            $http.post('/backend/hojafabricacion/cambiarlotelineafabricacion',  postParams  , config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
       }

       function removeLineaDuplicada(lineaHojaFabricacionID, callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var postParams = $.param(
            {
                lineaHojaFabricacionID:lineaHojaFabricacionID
            }
            );
            console.log('setHojaFabricacionAccion postParams', postParams)
            $http.post('/backend/hojafabricacion/removelineaduplicada',  postParams  , config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
       }

       function setHojaFabricacionAccion(postParams,callback)
       {

           var config = {
               headers : {
                   'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
               }
           }
           var postParams = $.param(
            {
                "hojafabricacionaccion":JSON.stringify(postParams)
            }
           );
            console.log('setHojaFabricacionAccion postParams', postParams)
           $http.post('/backend/hojafabricacion/sethojafabricacionaccion',  postParams  , config)
           .then(getContentSuccess,getContentFailed);
           function getContentSuccess(data){ 
               callback(data.data);
           }
           function getContentFailed(data){
               
               return false;
           }
       }

       function getValidacionesHojaFabricacion(id_hoja_fabricacion_dada,categoria,callback) {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            $http.get('/backend/hojafabricacion/getvalidacioneshojafabricacion',  { params : {id_hoja_fabricacion:id_hoja_fabricacion_dada, categoria:categoria}  }  , config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
       }

       function getCategoriasFlujos(callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            $http.get('/backend/hojafabricacion/getcategoriasflujos',  { params : {}  }  , config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
       }

       function getFlujosHojaFabricacion(id_hoja_fabricacion, callback){
        var config = {
            headers  :{
                'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
            }
        }
        $http.get('/backend/hojafabricacion/getflujoshojafabricacion',  { params : {id_hoja_fabricacion:id_hoja_fabricacion}  }  , config)
        .then(getContentSuccess,getContentFailed);
        function getContentSuccess(data){ 
            callback(data.data);
        }
        function getContentFailed(data){
            
            return false;
        }
       }

       function setFlujoHojaFabricacion(id_hoja_fabricacion, valores, categoria, callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            console.log("valores flujo desde el service de actualizar", valores);
            var postParams =$.param({
                valores:JSON.stringify(valores),
                id_hoja_fabricacion:id_hoja_fabricacion,
                categoria:categoria,
            });

            $http.post('/backend/hojafabricacion/setflujohojafabricacion',  postParams  , config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
            console.log('sethojafabricacion error', data)
                
                return false;
            }
       }

       function finalizarFlujoHojaFabricacion(id_hoja_fabricacion, categoria, callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var postParams =$.param({
                id_hoja_fabricacion:id_hoja_fabricacion,
                categoria:categoria,
            });

            $http.post('/backend/hojafabricacion/finalizarflujohojafabricacion',  postParams  , config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
            console.log('sethojafabricacion error', data)
                
                return false;
            }
       }

       function setValidaciones(postParams,callback)
       {

            var config = {
               headers : {
                   'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
               }
            }
            postParams =$.param({
                validaciones_hechas:JSON.stringify(postParams.hojaFabricacion.validaciones_hechas),
                id_hoja_fabricacion:postParams.hojaFabricacion.id,
                categoria:postParams.hojaFabricacion.categoria.id, 
                unidades_validacion:postParams.unidades_validacion,
            });
            console.log('setValidaciones',postParams)

           $http.post('/backend/hojafabricacion/setvalidacioneshojafabricacion',  postParams  , config)
           .then(getContentSuccess,getContentFailed);
           function getContentSuccess(data){ 
               callback(data.data);
           }
           function getContentFailed(data){
            console.log('sethojafabricacion error', data)
               
               return false;
           }
           
       }

       function finalizarValidacion(postParams, callback)
       {

            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            postParams =$.param({
                id_hoja_fabricacion:postParams.hojaFabricacion.id,
                categoria:postParams.hojaFabricacion.categoria.id, 
            });
            $http.post('/backend/hojafabricacion/finalizarvalidacion',  postParams  , config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
            console.log('sethojafabricacion error', data)
                
                return false;
            }

       }

       function desvalidarValidacion(postParams, comentario, callback)
       {

            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            postParams =$.param({
                id_hoja_fabricacion:postParams.hojaFabricacion.id,
                categoria:postParams.hojaFabricacion.categoria.id,
                comentario:comentario,  // este es el comentario que se envía al desvalidar
            });
            $http.post('/backend/hojafabricacion/desvalidar',  postParams  , config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
            console.log('sethojafabricacion error', data)
                
                return false;
            }

       }

       function getValidaciones(id_hoja_fabricacion, categoria_id)
       {

            var config = {
               headers : {
                   'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
               }
            }
            var postParams =$.param({
                id_hoja_fabricacion:id_hoja_fabricacion,
                categoria:categoria_id, 
            });

           return $http.post('/backend/hojafabricacion/getvalidacioneshojafabricacionhechas',  postParams  , config)
           .then(getContentSuccess,getContentFailed);
           function getContentSuccess(data){ 
            //    callback(data.data);
                return data.data;
           }
           function getContentFailed(data){
            console.log('getvalidacioneshojafabricacionhechas error', data)
               
               return false;
           }
           
       }
       function desecharStock(stock_id,callback)
       {
           var config = {
               headers : {
                   'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
               },
           }
           var data = $.param({ 
               stock_id:stock_id,
           });
           $http.post('/backend/hojafabricacion/desecharstock',data, config)
           .then(getContentSuccess,getContentFailed);
           function getContentSuccess(data){ 
               callback(data.data);
           }
           function getContentFailed(data){
               
               return false;
           }
       }
       function getLoteFifoAlmacen(material_id, composicion, almacen_id, callback){
            var config = {
                headers  :{
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            $http.get('/backend/hojafabricacion/getlotefifoalmacen',  { params : {material_id:material_id, composicion_material:composicion, almacen_id:almacen_id}  }  , config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
       }
       function getEstadisticas(hoja_id,callback){
            var config = {
                headers  :{
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            $http.get('/backend/hojafabricacion/getestadisticas',  { params : {hoja_id:hoja_id}  }  , config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
       }

        function updateUnidadesCajas(hoja_id,cajas_completas,unidades_sueltas,callback)
       {
           var config = {
               headers : {
                   'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
               },
           }
           var data = $.param({ 
               hoja_id:hoja_id,
               cajas_completas:cajas_completas,
               unidades_sueltas:unidades_sueltas,
           });
           $http.post('/backend/hojafabricacion/updateunidadescajas',data, config)
           .then(getContentSuccess,getContentFailed);
           function getContentSuccess(data){ 
               callback(data.data);
           }
           function getContentFailed(data){
               
               return false;
           }
       }
   }
})();